import { render, staticRenderFns } from "./OpusApply.vue?vue&type=template&id=72b1c4d9&scoped=true&"
import script from "./OpusApply.vue?vue&type=script&lang=js&"
export * from "./OpusApply.vue?vue&type=script&lang=js&"
import style0 from "./css/OpusApply.scss?vue&type=style&index=0&id=72b1c4d9&lang=scss&scoped=true&"
import style1 from "./OpusApply.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b1c4d9",
  null
  
)

export default component.exports